module.exports = __webpack_public_path__ + "static/media/bg-small.80cd96e2.svg";